
import sliderline from './imgs/sliderline.svg';
import slidercircle from './imgs/slidercircle.svg';
import React from 'react';
import Tappable from 'react-tappable';

class Slider extends React.Component {

constructor(props) {
    super(props);
    this.state = {xaxis: 50,
        width: null, 
        currentWidth: null,
        dragging: false,
        sliderPrice: 499, 
        loadingPercent: 50,
        firstTime: true
      };
  }

  componentDidMount() {
    document.getElementById('slidercircle').ondragstart = function() { return false; };
      let width = document.querySelector('#sliderline').clientWidth;
    this.setState({
      width: width,
      currentWidth: width / 2 - 10
    });
  }
  

  
dragging = (e) => {

      // Callback function
      let slider = document.querySelector('#sliderline');
      let sliderWidth = slider.clientWidth - 20;
      let windowMaxW = window.innerWidth;
      
      let wDiff = (windowMaxW - sliderWidth) / 2;
      let mX =  Math.round(e.touches[0].clientX - wDiff);
   
     
        

        if(mX > sliderWidth){
          mX =  sliderWidth;
        }
        else if(mX < 0){
          mX = 0;
        }
        let loadingPrecent = (mX / sliderWidth);
        let newPrice = Math.round((loadingPrecent * 949) + 50)
        newPrice = Math.ceil(newPrice / 10) * 10;
       

        this.setState({
          currentWidth: mX, 
          sliderPrice: newPrice,
          dragging: true

        })

        let thousand = document.getElementById('thousand');
        let fifty = document.getElementById('fifty')

        if(newPrice > 800){     
          thousand.classList.add('fade');
        }
        if(newPrice < 800){
          thousand.classList.remove('fade');
        }

        if(newPrice < 150){
          fifty.classList.add('fade');
        }
        if(newPrice > 150) {
          fifty.classList.remove('fade');
        }
  }

  draggingMouse = (e) => {

         // Callback function
         let slider = document.querySelector('#sliderline');
         let sliderWidth = slider.clientWidth - 10;
         let windowMaxW = window.innerWidth;
         
         let wDiff = (windowMaxW - sliderWidth) / 2;
         let mX =  Math.round(e.clientX - wDiff);
       
        
           
   
           if(mX > sliderWidth){
             mX =  sliderWidth;
           }
           else if(mX < 0){
             mX = 0;
           }
           let loadingPrecent = (mX / sliderWidth);
           let newPrice = Math.round((loadingPrecent * 949) + 50)
           newPrice = Math.ceil(newPrice / 10) * 10;
          
   
           this.setState({
             currentWidth: mX, 
             sliderPrice: newPrice,
             dragging: true
   
           })
   
           let thousand = document.getElementById('thousand');
           let fifty = document.getElementById('fifty')
   
           if(newPrice > 800){     
             thousand.classList.add('fade');
           }
           if(newPrice < 800){
             thousand.classList.remove('fade');
           }
   
           if(newPrice < 150){
             fifty.classList.add('fade');
           }
           if(newPrice > 150) {
             fifty.classList.remove('fade');
           }
  }


  
 render(){
    let xpos = this.state.currentWidth;
    
  return (
   
     
                <div className='row'>
                    <div className='col-1 col-md-3'></div>
            
                    <div className='col-10 col-md-6 d-flex flex-column mb-5'>
                
          
                    <img id='sliderline' style={{ paddingTop: '0.5rem' }} src={sliderline}></img>

                    <Tappable onTouchMove={this.dragging} onMouseMove={this.draggingMouse}   style={{position: 'absolute', width: '2.2rem', transform: 'translateX(' + xpos + 'px)', cursor:'pointer'}}><img id='slidercircle' style={{ width: '1.6rem', cursor:'pointer' }} src={slidercircle}></img><span id='budget' className='text-center text-white'><strong>{this.state.sliderPrice}$</strong></span></Tappable>
                    <div className='row d-flex justify-content-between'>
                        <div className='col-1'>
                          <p className='text-black-50 slideSource' id='fifty'>50$</p>
                        </div>
                        <div className='col-2 col-md-1'>
                          <p className='text-black-50 slideSource' id='thousand'>1000$</p>
                        </div>
                    </div>
                    </div>
                    <div className='col-1 col-md-3'></div>
                </div>
      
  );
  }
}

export default Slider;